module.exports = __webpack_public_path__ + "img/20210309.c5704c51.gif";